import Accordion from '@components/Accordion/Accordion';
import BoxBoloes from '@components/BoxBoloes/BoxBoloes';

new Vue({
  el: '[data-vue=page-results-detail]',
  components: {
    Accordion,
    BoxBoloes
  },
  data () {
    return {
    }
  },
  methods: {
  }
});
